import BaseModel from '../core/BaseModel'
import AreaModel from "@/models/AreaModel";
//import gql from 'graphql-tag'
export default class StatementDetailModel extends BaseModel {

    constructor() {
        super({ 
                name: "statementDetail",
                tableName: 'users', 
                label: "Bảng kê chi tiết văn bản", 
                display_key: 'fullname', 
                default_order: { key: 'created_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "String",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã nhân viên',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Họ và tên',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false,
            },
                area_id: {
                name: "area_id",
                label: "Mã khu vực",
                width: 9,
                class: "center",
                type: "Selection",
                models: new AreaModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
           /* areas: {
                refs: 'areas {id name:code}',
                display: false
            },*/
            doc_confirmed_ref: {
                refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_confirmed: {
                name: 'total_doc_confirmed', 
                type: "Computed",
                label: 'Tổng văn bản nhận',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_confirmed = data.view_tdv_total_doc_confirmed_aggregate.aggregate.count
                },
            },
            doc_waiting_no_scan_ref: {
                refs: 'view_tdv_total_doc_waiting_no_scan_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_waiting_no_scan: {
                name: 'total_doc_waiting_no_scan', 
                type: "Computed",
                label: 'Văn bản mới (VB TĐV chưa scan)',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_waiting_no_scan = data.view_tdv_total_doc_waiting_no_scan_aggregate.aggregate.count
                },
            },
            doc_normal_tt_gn_nt3_ref: {
                refs: 'view_tdv_total_doc_normal_tt_gn_nt3_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_normal_tt_gn_nt3: {
                name: 'total_doc_normal_tt_gn_nt3', 
                type: "Int",
                label: 'Văn bản thường loại 1 + 2 (TT,GN,NT3)',
                width: 12,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_normal_tt_gn_nt3 = data.view_tdv_total_doc_normal_tt_gn_nt3_aggregate.aggregate.count
                },
            },
            doc_doc_normal_kt_ref: {
                refs: 'view_tdv_total_doc_normal_kt_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_normal_kt: {
                name: 'total_doc_normal_kt', 
                type: "Int",
                label: 'Văn bản loại 1+2 Không thành',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_normal_kt = data.view_tdv_total_doc_normal_kt_aggregate.aggregate.count
                },
            },
            doc_doc_normal_ny_ref: {
                refs: 'view_tdv_total_doc_normal_ny_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_normal_ny : {
                name: 'total_doc_normal_ny', 
                type: "Int",
                label: 'Văn bản loại 1+2 Niêm yết',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_normal_ny = data.view_tdv_total_doc_normal_ny_aggregate.aggregate.count
                },
            },
            doc_doc_type3_ref: {
                refs: 'view_tdv_total_doc_type3_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_type3 : {
                name: 'total_doc_type3', 
                type: "Int",
                label: 'Văn bản Loại 3 (trùng)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type3 = data.view_tdv_total_doc_type3_aggregate.aggregate.count
                },
            },
            doc_doc_type4_ref: {
                refs: 'view_tdv_total_doc_type4_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_type4: {
                name: 'total_doc_type4', 
                type: "Int",
                label: 'Văn bản trả tòa loại 4',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type4 = data.view_tdv_total_doc_type4_aggregate.aggregate.count
                },
            },
            doc_doc_type5_ref: {
                refs: 'view_tdv_total_doc_type5_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_type5: {
                name: 'total_doc_type5', 
                type: "Int",
                label: 'Văn bản loại 5 (Tỉnh)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type5 = data.view_tdv_total_doc_type5_aggregate.aggregate.count
                },
            },
            doc_doc_remaining_ref: {
                refs: 'view_tdv_total_doc_remaining_aggregate {aggregate {count}} view_tdv_total_doc_complete_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_done: {
                name: 'total_doc_done',
                type: "Int",
                label: 'Tổng VB hoàn thành',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    /*var total_doc_normal_tt_gn_nt3 = data.view_tdv_total_doc_normal_tt_gn_nt3_aggregate.aggregate.count;
                    var total_doc_normal_kt = data.view_tdv_total_doc_normal_kt_aggregate.aggregate.count;
                    var total_doc_normal_ny = data.view_tdv_total_doc_normal_ny_aggregate.aggregate.count;
                    var total_doc_type3 = data.view_tdv_total_doc_type3_aggregate.aggregate.count;
                    var total_doc_type4 = data.view_tdv_total_doc_type4_aggregate.aggregate.count;
                    var total_doc_type5 = data.view_tdv_total_doc_type5_aggregate.aggregate.count;
                    data.total_doc_done = total_doc_normal_tt_gn_nt3 + total_doc_normal_kt + total_doc_normal_ny + total_doc_type3 + total_doc_type4 + total_doc_type5;*/
                    data.total_doc_done = data.view_tdv_total_doc_complete_aggregate.aggregate.count;
                },
            },
            total_doc_remaining: {
                name: 'total_doc_remaining', 
                type: "Int",
                label: 'Văn bản tồn',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_remaining = data.view_tdv_total_doc_remaining_aggregate.aggregate.count
                },
            },
        },)
    }

}